module.exports = __webpack_public_path__ + "static/img/beer.ec75c38f.png";